import { render, staticRenderFns } from "./ProductButtons.vue?vue&type=template&id=6f2942b3&lang=html"
import script from "./ProductButtons.vue?vue&type=script&lang=js"
export * from "./ProductButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports